import { tooltipStyle } from 'utils/styles';

export default class Tooltip {
  constructor(sel) {
    this.tooltip = null;

    if (!sel.select('.tooltip').node()) {
      this.tooltip = sel.append('div').attr('class', tooltipStyle);
    } else {
      this.tooltip = sel.select('.tooltip');
    }
  }

  show(content, pos) {
    const { tooltip } = this;
    tooltip.html(content);
    const w = tooltip.node().offsetWidth;
    const h = tooltip.node().offsetHeight;
    const x = pos[0] - w * 0.5;
    const y = pos[1] - (h + 10);

    tooltip.styles({
      opacity: 0.9,
      left: `${x}px`,
      top: `${y}px`,
    });
  }

  hide() {
    const { tooltip } = this;
    tooltip.styles({ 'opacity': 0 });
  }
}
